import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { LogBatchPayload, LoggerHttpSender } from './logger.types';

@Injectable({ providedIn: 'root' })
export class DefaultLoggerHttpSender implements LoggerHttpSender {
  private warned = false;
  constructor(private http: HttpClient) {}

  async send(endpoint: string, payload: LogBatchPayload): Promise<void> {
    try {
      await firstValueFrom(
        this.http.post(endpoint, payload, { withCredentials: true, observe: 'response' }),
      );
      this.warned = false;
    } catch (err) {
      if (!this.warned) {
        this.warned = true;
        console.warn('[logger] failed to ship events; further failures will be silent', err);
      }
    }
  }
}
